import React from "react";
import { useTranslation } from "react-i18next";
import LabelValueBadge from "../../../common/components/LabelValueBadge";

const ModuleCardLecturer = ({ lecturer }) => {
  const { t } = useTranslation();

  return (
    <LabelValueBadge
      label={t("student.course.modulecard.lecturer")}
      value={lecturer}
      size="sm"
      variant="solid"
    />
  );
};

export default ModuleCardLecturer;
